import * as React from 'react';

import { cn } from '@shared/lib/utils';

import { Spinner } from './spinner';

export interface LoadingStatusProps extends React.HTMLAttributes<HTMLDivElement> {
  label: React.ReactNode;
}

const LoadingStatus = React.forwardRef<HTMLDivElement, LoadingStatusProps>(
  ({ className, label, ...props }, ref) => (
    <div
      ref={ref}
      role="status"
      aria-live="polite"
      className={cn(
        'flex min-w-0 items-center gap-2 rounded-md border border-border bg-muted/40 px-3 py-2 text-sm text-muted-foreground',
        className
      )}
      data-slot="loading-status"
      {...props}
    >
      <Spinner size="sm" role="presentation" aria-hidden="true" className="shrink-0" />
      <span className="min-w-0 break-words">{label}</span>
    </div>
  )
);
LoadingStatus.displayName = 'LoadingStatus';

export { LoadingStatus };
